export default __webpack_public_path__ + "static/14_15-c44850bac116748b3115c436a8bb174a.png";